import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { Button, Col, Dropdown, MenuProps, Row, notification, Tag } from 'antd';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfPlanContext,
  UserPlanDataContext,
  UserSkillDataContext,
} from '../../../../../../../context';
import EditPlan from '../edit-plan';
import { useParams } from 'react-router-dom';
import { PlanType } from '../../../../../../utils/dict/PlanType';
import ProgressBar from '../../../../../progress';
import PlanEditModal from '../edit-plan';
import DeleteModal from '../../../../../modal/delete';

interface PlanDetailProps {
  id: string;
  skill_id: number;
  skill_name: string;
  skill_type: any;
  start_date: string;
  end_date: string;
  plan_type: any;
  task: Array<any>;
  show_in_resume: boolean;
}

const PlanDetail: React.FC<PlanDetailProps> = ({
  id,
  skill_id,
  skill_name,
  skill_type,
  start_date,
  end_date,
  plan_type,
  task,
  show_in_resume
}: PlanDetailProps): JSX.Element => {
  const [iseditable, setIsEditable] = useState<boolean>(false);
  const { userPlanData, setUserPlanData } = useContext(UserPlanDataContext);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfPlans, setNumberOfPlans } = useContext(NumberOfPlanContext);

  const openNotification = (notificationType: 'success' | 'info' | 'warning' | 'error', skill_name: string) => {
    notification[notificationType]({
      message: notificationType === 'info' ? `Deleting plan of ${skill_name}` : (notificationType === 'success' ? `Deleted plan of ${skill_name} Successfully` : (notificationType === 'error' ? `An error occured while deleting plan of ${skill_name}` : "")),
    });
  };

  const handleDelete = () => {
    openNotification('info', skill_name);
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/plans';
      reqBody = { profile_id: employeeId, plan_id: id, status: 3 };
    } else {
      url = '/api/v1/profile/plans';
      reqBody = { plan_id: id, status: 3 };
    }
    axiosInstance.post(url, reqBody).then((response) => {
      const filteredPlanData = response.data.plans.filter((plan: any) => {
        return plan.status.id === 1;
      });
      const orderedPlans = response.data.order.map((planId: number) =>
        filteredPlanData.find((plan: any) => plan.id === planId)
      ).filter((item: any) => item !== undefined);
      setUserPlanData(orderedPlans);
      setNumberOfPlans(orderedPlans.length);
      openNotification('success', skill_name);
    }).catch((error) => {
      openNotification('error', skill_name);
    });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  return (
    <>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      <Row
        className={styles.row}
        gutter={{ xs: 8, sm: 16 }}
        style={{ margin: '5px', marginBottom: '10px' }}
      >
        <div style={{ display: "flex", alignItems: "center", position: "absolute", bottom: "5px", right: "5px" }}>
          {
            show_in_resume ? (
              <Tag color="success">
                Show in resume: Yes
              </Tag>
            ) : (
              <Tag color="error">
                Show in resume: No
              </Tag>
            )
          }
        </div>
        <Col span={12}>
          <Row>
            <h1 className={styles['skill-text']}>
              <b>{skill_name}</b>
            </h1>
          </Row>
          <Row>
            <p className={styles['category-name']}>{skill_type['name']}</p>
          </Row>
        </Col>
        <Col span={11}>
          <Row>
            <Col flex={2}>
              <p>
                <span className={styles.title}>From : </span>
                <span className={styles.value}>{start_date}</span>
              </p>
            </Col>
            <Col flex={2}>
              <p>
                <span className={styles.title}>To : </span>
                <span className={styles.value}>{end_date}</span>
              </p>
            </Col>
          </Row>
          <p>
            <span className={styles.title}>Plan Type : </span>
            <span className={styles.value}>{PlanType[plan_type['id']]}</span>
          </p>
        </Col>
        {iseditable ? (
          <></>
        ) : (
          <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
            <Button
              type="text"
              style={{
                position: 'absolute',
                right: '5px',
                border: 'hidden',
                textDecoration: 'blue',
                top: "10px"
              }}

            >
              <img
                src="/more_vert.png"
                style={{
                  marginLeft: 'auto',
                  marginRight: '0px',
                  height: '15px',
                  width: '5px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Dropdown>
        )}

        <Row
          style={{
            width: '100%',
            marginLeft: '0px',
            marginRight: '5px',
            marginBottom: '0px',
          }}
          gutter={{ xs: 8, sm: 16 }}
        >
          <Col span={12}>
            <p className={styles['task-status-text']}>
              {
                task.filter((item) => {
                  return item.status.id === 1;
                }).length
              }{' '}
              out of {task.length} To-Do has been completed
            </p>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={6}>
                <p className={styles['progress-status-text']}>
                  Task Progress :{' '}
                </p>
              </Col>
              <Col span={18}>
                <ProgressBar
                  {...{
                    percent: Math.ceil(
                      (task.filter((item) => {
                        return item.status.id === 1;
                      }).length /
                        task.length) *
                      100
                    ),
                  }}
                ></ProgressBar>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>

      <PlanEditModal
        key={id}
        {...{
          isModalOpen: iseditable,
          setIsModalOpen: setIsEditable,
          id,
          skill_id,
          start_date,
          end_date,
          plan_type,
          task,
          show_in_resume
        }}
      />
    </>
  );
};

export default PlanDetail;
